<template>
<div class="coverage__app">
  <div class="coverage__header">
    <div class="mt-3 mb-1 mb-sm-3">
      <button @click="activeSport = 'football'" :class="{'active':(activeSport=='football')}">Football</button>
      <button @click="activeSport = 'other_sports'" :class="{'active':(activeSport=='other_sports')}">Other Sports</button>
    </div>

    <div class="mb-3 d-flex flex-column flex-md-row">
      <div class="search_wrap">
        <input type="text" id="search" name="search" v-on:input="debounceInput" placeholder="Search" autocomplete="off" >
      </div>
      <div>
        <a v-if="activeSport == 'football' && download.soccer" :href="download.soccer.url ? download.soccer.url : download.soccer" target="_blank" class="coverage__download">Download full overview</a>
        <a v-if="activeSport == 'other_sports' && download.other_sports" :href="download.other_sports.url ? download.other_sports.url : download.other_sports" target="_blank" class="coverage__download">Download full overview</a>
      </div>
      <div v-if="note" class="px-md-4 small" v-html="note"></div>
    </div>

    <table>
      <tr> <!--  Only very first row. Used to populate theader -->

        <td class="coverage__explainers">
          <span><IconPre />Pre match</span>
          <span><IconLive />Live</span>
          <span><IconPost />Post Match</span>
        </td>

        <td class="coverage__type" v-for="(description, type) in coverage[this.activeSport]">
          <span class="coverage__type-text" v-html="type"></span>
          <IconInfo />
          <div class="coverage__type-description">{{description}}</div>
        </td>
      </tr>
    </table>
  </div>
  <div class="coverage__innerwrapper">

    <div class="mt-5 bm-5 text-center" v-if="Object.keys(filteredData).length === 0">
      <h5>No entries found. Try broaden your search a bit!</h5>
    </div>

    <!--
    Football
    -->
    <div v-for="(leagues, country) in filteredData" v-if="activeSport == 'football'" class="groupedLeagues">
      <h5>
        <span :class="'fi fis fi-'+leagues[0].country.value.toLowerCase()"></span>
        {{ country }}
      </h5>

      <table>
        <tr v-for="league in sortByTitle(leagues)" tabindex="0">
          <td class="league-title" v-html="league.title"></td>
          <td v-for="(value, coverage_type) in coverage[activeSport]" >
            <IconPre v-if="league.coverage[coverage_type] === 'b'" />
            <IconLive v-if="league.coverage[coverage_type] === 'l'" />
            <IconPost v-if="league.coverage[coverage_type] === 'a'" />

            <IconPre v-if="league.coverage[coverage_type] === 'none'"  style="opacity:0;"/>
          </td>
        </tr>
      </table>
    </div>

    <!--
    Other Sports
    -->
    <div v-for="(leagues, sport) in sortObjectByKey(filteredData)" v-if="activeSport == 'other_sports'" class="groupedLeagues">
      <h5>{{ sport }}</h5>
      <table>
        <tr v-for="league in sortByTitle(leagues)" tabindex="0">
          <td>
            <span :class="'fi fis fi-'+league.country.value.toLowerCase()"></span>
            <span v-html="league.title" />
          </td>
          <td v-for="(value, coverage) in league.coverage">
            <IconPre v-if="value === 'b'" />
            <IconLive v-if="value === 'l'" />
            <IconPost v-if="value === 'a'" />
            <IconPre v-if="value === 'none'" style="opacity:0;"/>
          </td>
        </tr>
      </table>
    </div>

  </div>

</div>
</template>

<script>
import _ from 'lodash';
import _debounce from 'lodash/debounce';
// import iconInfo from "./../../../dist/assets/img/icon_info.svg";
// import iconLive from "./../../../dist/assets/img/icon_live-match.svg";
// import iconPost from "./../../../dist/assets/img/icon_post-match.svg";
// import iconPre from "./../../../dist/assets/img/icon_pre-match.svg";
import IconPre from "./IconPre.vue";
import IconInfo from "./IconInfo.vue";
import IconLive from "./IconLive.vue";
import IconPost from "./IconPost.vue";

export default {
  props: {
    leagues: {
      type: Object,
      default: {}
    },
    coverage: {
      type: Array,
      default: []
    },
    download: {
      type: Array,
      default: []
    },
    note: {
      type: String,
      default: null
    }
  },
  components: {
    IconInfo,
    IconPre,
    IconLive,
    IconPost,
  },
  data() {
    return {
      // activeSport: 'other_sports',
      activeSport: 'football',
      search: '',
    }
  },
  computed: {
    leaguesOrderedByCountry: function() {
      return _.orderBy(this.leagues, 'country.label')
    },

    groupedLeagues: function () {
      // Football
      if(this.activeSport == 'football'){
        let leaguesGroupedByCountry = this.leaguesOrderedByCountry.filter(({sport}) => sport === 'Football').reduce(function(r, a) {
          r[a.country.label] = r[a.country.label] || [];
          r[a.country.label].push(a);
          return r;
        }, Object.create(null));

        return leaguesGroupedByCountry;
      }

      // Other sports
      else{
        let leaguesGroupedBySport = this.leaguesOrderedByCountry.filter(({sport}) => sport != 'Football').reduce(function(r, a) {
          r[a.sport] = r[a.sport] || [];
          r[a.sport].push(a);
          return r;
        }, Object.create(null));
        return leaguesGroupedBySport;
      }
    },

    filteredData() {
      return Object.keys(this.groupedLeagues).reduce((a, cKey) => {
        const data = this.filterValue(this.groupedLeagues[cKey]);
        if (data.length) {
          a[cKey] = data;
        }
        return a;
      }, {});
    },

  },
  methods: {
    filterValue(groupedLeagues) {
      return groupedLeagues.filter(item => {
        let itemTitleUpper = item.title.toUpperCase();
        let itemSportUpper = item.sport.toUpperCase();
        let itemCountryUpper = item.country.label.toUpperCase();
        let searchUpper = this.search.toUpperCase();
        return itemTitleUpper.indexOf(searchUpper) > -1 || itemCountryUpper.indexOf(searchUpper) > -1 || itemSportUpper.indexOf(searchUpper) > -1;
      });
    },
    sortByTitle: function (list) {
      return _.orderBy(list, 'title', 'asc');
    },
    sortObjectByKey: function(o) {
      return Object.keys(o).sort().reduce((r, k) => (r[k] = o[k], r), {});
    },
    debounceInput: _.debounce(function (e) {
      this.search = e.target.value;
    }, 700)
  },
  mounted() {
    // console.log(this.groupedLeagues);
    // console.log(this.leagues);
    // console.log(this.sortObjectByKey(this.filteredData));
  }
}
</script>
